module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_LB&MB&ISO TANKER_LHD_THUMB.01651830.jpg";